import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SettingComponent } from './setting.component';
import { DataSourceComponent } from './data-source/data-source.component';
import { PlatformSettingsComponent } from './platform-settings/platform-settings.component';
// import { CustomerComponent } from '@app/customer/customer.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { environment } from '@env/environment';

const enableGlobalSearch = true; // environment.enableGlobalSearch;

const childrenRoutes = [
  { path: 'data-source', component: DataSourceComponent },
  {
    path: 'config-settings',
    loadChildren: () =>
      import('../pics-config-login-settings/pics-config-login-settings.module').then(
        m => m.PicsConfigLoginSettingsModule
      )
  },
  {
    path: 'platform-settings',
    component: PlatformSettingsComponent
  }
];

if (enableGlobalSearch) {
  childrenRoutes.push({
    path: 'global-search',
    loadChildren: () =>
      import('@pics-core/elasticsearch').then(
        m => m.ElasticsearchModule
      )
  });
}

childrenRoutes.push({ path: '**', redirectTo: 'data-source', pathMatch: 'full' } as any);

const routes: Routes = [
  {
    path: '',
    component: SettingComponent,
    children: childrenRoutes
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes),ReactiveFormsModule,FormsModule],
  exports: [RouterModule]
})
export class SettingRoutingModule {}
